<div [id]="modalable?.getModalId()"
     class="modal quicklink-modal hsm-modal" data-backdrop="static" data-keyboard="false" role="dialog" tabindex="-1">

    <div [class.error]="err" class="modal-dialog modal-fullscreen" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <ng-container>
                    @if (loading) {
                        <div class="loading">
                            <div>Lade Daten</div>
                            <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    }
                    @if (!loading) {
                        <am-root [config]="hsmConfig"></am-root>
                        @if (err) {
                            <div class="error">
                                <div class="error-message">
                                    <span>{{ err }}</span>
                                    <button (click)="close()" data-bs-dismiss="modal">zurück zum Buch</button>
                                </div>
                            </div>
                        }
                    }
                </ng-container>
            </div>

            <div class="drag-handler">
                <div class="modal-toolbar dropdown">
                    <button (click)="close()" class="btn btn-default" data-bs-dismiss="modal" id="closeDropdown"><img
                            src="{{ 'hsm-modal/hsm-window-close.png' | asset }}"></button>
                </div>
            </div>
        </div>
    </div>
</div>
